import styled from 'styled-components';
import colors from '../../../helpers/colors';
import fonts from '../../../helpers/fonts';
import mediaQuery from '../../../helpers/mediaQuery';
import spacing from '../../../helpers/spacing';
import LazyImg from '../../LazyImg';
import Link from '../../Link';
import { actionLinkStyle } from '../../Link/styles';
import RichText from '../../RichText';

export const ContactCardContainer = styled.div`
  display: flex;
  flex-flow: column nowrap;

  margin: ${spacing(2)} 0;
  padding: ${spacing(3)};
  border: 1px solid ${colors.cardBorder};
  border-radius: ${({ theme }) => `${theme.cardRadius}`};

  overflow-wrap: anywhere;

  ${mediaQuery.tabletPortrait`
    margin: ${spacing(2)} 0;
  `}
`;

export const ProfileImage = styled(LazyImg)`
  align-self: flex-start;
  height: ${spacing(8)};
  width: ${spacing(8)};
  & {
    border-radius: ${spacing(8)};
  }
`;

export const JobTitle = styled.div`
  ${fonts.paragraph}
  margin-top: ${spacing(2)};
`;

export const Name = styled.div`
  ${fonts.headingSmall}
  margin-top: ${spacing(0.5)};
`;

export const StyledLink = styled(Link)`
  ${fonts.paragraph}
  ${actionLinkStyle}
  margin-top: ${spacing(0.5)};
`;

export const CardRichText = styled(RichText)`
  ${fonts.paragraph}
  margin-top: ${spacing(0.5)};

  p,
  p + p {
    margin: 0;
    margin-top: ${spacing(0.5)};
  }
`;

export const LinkedInWrapper = styled.div`
  margin-top: ${spacing(0.5)};
  display: flex;
  align-items: center;
`;

export const LinkedInImage = styled(LazyImg)`
  margin-right: ${spacing(0.5)};
  height: ${spacing(4)};
  width: ${spacing(4)};
`;

export const LinkedInLink = styled(Link)`
  ${fonts.paragraph}
  ${actionLinkStyle}
  margin-top: 0;
`;

export const LogoImage = styled(LazyImg)`
  align-self: flex-start;
  margin: ${spacing(2)} 0 0;
  max-height: ${spacing(4)};
`;
